import React, { useState } from "react";
import Footer from "../../components/Footer_/Footer";
import AboutSec from "../../components/AboutSec_/AboutSec";
import CommonHero from "../../components/CommonHero_/CommonHero";
import CallToAction from "../../components/CallToAction/CallToAction";
import { Helmet } from "react-helmet";
import { Col, Container, Row, Spinner } from "react-bootstrap";
import styles from "./ContactScreen.module.css";
import axios from "axios";
import { Navigate, useNavigate } from "react-router-dom";
import TestimonialsBox from "../../components/TestimonialsBox/TestimonialsBox";
import { VerticalSlider } from "../System Education/System Education";

const SolarAndWindPower = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNum, setPhoneNum] = useState("");
  const [message, setMessage] = useState("");
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const history = useNavigate();

  const formSubmitHandler = (event) => {
    event.preventDefault();
    setLoading(true);
    axios
      .post("/send-contact-form", {
        name,
        email,
        phoneNumber: phoneNum,
        message,
      })
      .then((response) => {
        if (response.data.msg === "success") {
          setError(false);
          setSuccess("Form Submitted Successfully!");
          setLoading(false);
          setEmail("");
          history("/thank-you");
        } else if (response.data.msg === "fail") {
          setSuccess(false);
          setError("Email failed to send, try again by reloading the page.");
          setLoading(false);
          setEmail("");
        }
      });
  };
  return (
    <>
      <Helmet>
        <title>Solar Panel Installer in Milton | Solar Installation</title>
        <meta name="keywords" content="Batteries in Ontario" />
        <link
          rel="canonical"
          href="https://www.truoffgrid.com/solar-installation"
        />
        <meta
          name="description"
          content="Get expert solar panel installation services from TRU Off Grid. We deliver reliable residential, commercial, off-grid, and mobile solar solutions in Milton, ON."
        />
      </Helmet>
      <CommonHero
        shopHero={true}
        heading="Solar + ESS Installation"
      />
      <AboutSec
        heading={"We Make Solar and Energy Storage Solutions Simple"}
        subHeading={""}
        text={`At TRU Off Grid, we are experts in Residential, Cottage, Off Grid and Commercial Solar and Energy Storage Solutions. We are professional, reputable and insured installers who will customize a solar solution to meet your application and requirements. Please give us a call to discuss how we can help.`}
    
        img={"/images/our-metal-tile-roof-array-install.jpg"}
        cta={true}
        imgBorderRad={true}
      />
      <CallToAction cta2={true} />
      <AboutSec
        heading={"Solar Installation"}
        subHeading={"Install with the TRU Team "}
        // text={`TRU Off Grid provides a complete vertically integrated process, ensuring end-to-end control and quality throughout your entire Solar project. We assist with the initial system design based on energy usage, roof layouts, supply of materials, obtaining building permits & hydro approval (for Net-Metering), additional consulting and of course, the installation! As of today, the TRU team has installed, managed and repaired just over 650kW DC of Solar, and 200kW of battery backup storage. We are fully insured with $5m in liability, working at heights certified & over 5 years of installation experience.`}
        text={`TRU Off Grid provides a complete vertically integrated process, ensuring end-to-end control and quality throughout your entire solar project. We assist with the initial system design based on energy usage, roof layouts, material supply, obtaining building permits & hydro approval (for Net-Metering), additional consulting, and, of course, the installation! As of today, the TRU team has installed, supplied and managed 1+ MW DC of solar and 3+ MWh of battery backup storage. We are fully insured with $5m in liability, Working at Heights certified & over 5 years of installation experience.`}
  
        img={"/images/our-crew-setting-a-panel-on-the-site-office-c-can.jpg"}
        reverse={true}
        cta={true}
        imgBorderRad={true}
      />
      <AboutSec
        heading={"How Solar Net-Metering Works"}
        subHeading={"Save Money with Solar"}
        text={`1. Solar Panels absorb sunlight, which then produces a DC electrical current. 2. The DC current produced travels through a Solar Inverter, which then converts DC power into accessible AC power for home electrical use or grid feedback .3. As normal, electricity is distributed throughout the household for any power source required. 4. If households are producing more Solar Power than electricity consumed, excess power is sent back to the grid for future credit use (cloudy days & winter months) 5. This results in your newly installed bi-directional meter spinning backwards, offsetting your Hydro Bill !`}
        img={"/images/solar-net-metering.webp"}
        cta={true}
        imgBorderRad={true}
      />
      <AboutSec
        heading={"EP CUBE 2.0 BY CANADIAN SOLAR"}
        subHeading={"HYBRID RESIDENTIAL ENERGY STORAGE"}
        text={`Pair your solar with the Canadian Solar EP Cube 2.0, an all-in-one hybrid inverter and LiFePO4 battery. It stacks in
5 kWh modules from 5 to 40 kWh per unit, up to 120 kWh per system, and delivers up to 11.5 kW of AC power. The
Smart Gateway switches your whole home to battery power automatically during an outage, and the EP Cube
2.0 can charge on low-cost overnight power and run your home through on-peak hours, a big advantage on
Ultra-Low Overnight rates. Six solar inputs suit complex roofs, it works with backup generators and Level 2 EV
chargers, it is rated for outdoor wall or floor mounting, and it is backed by a 10-year warranty. Contact us today
for your EP Cube 2.0 quote.`}
      
        img={"/images/p09-ep-cube-20-section-garage-install.jpg"}
        reverse={true}
        cta={true}
        imgBorderRad={true}
      />
      <AboutSec
        heading={"EG4 HOME AND OFF-GRID SYSTEMS"}
        subHeading={"WHOLE-HOME BACKUP AND OFF-GRID"}
        text={`EG4 is our go-to platform for whole-home backup and off-grid living. EG4 hybrid inverters with the GridBOSS run
your whole home through an outage and manage a backup generator, while the EG4 12000XP and 6000XP
power off-grid cottages, cabins and workshops. Every system uses EG4 14.3 kWh LiFePO4 batteries, in indoor or
all-weather outdoor models, with a 10-year battery warranty, and you can add batteries as your needs grow.
Paired with new rooftop solar, EG4 systems qualify for the Home Renovation Savings rebate.`}
      
        img={"/images/eg4-solar-install-text.jpg"}
        reverse={false}
        cta={true}
        imgBorderRad={true}
      />
      <AboutSec
        // heading={"Canadian Greener Homes Loan (CGHL)"}
        // subHeading={"Federal Loan"}
        // text={`Natural Resources Canada is currently offering a $40,000, interest-free loan, with a 10-year repayment term, to support the cost of your Residential Solar System, known as the Canada Greener Homes Loan! The maximum eligible loan amount is calculated based on the retrofits selected in the application and the quotes for this work. Apply for loan today - <a target="no_blank" href="https://www.cghli.ca/home">https://www.cghli.ca/home</a>`}
        subHeading={"PROVINCIAL REBATE"}
        heading={"HOME RENOVATIONS SAVINGS REBATE"}
        text={`The Home Renovations Savings Rebate is a provincial program that provides financial incentives for homeowners who install energy-efficient upgrades, including solar and battery energy storage systems. Eligible projects can receive rebates of up to $10,000 when solar panels and battery storage are installed together. Solar installations qualify for $1,000 per kW up to $5,000, while battery storage qualifies for $300 per kWh up to $5,000. Systems must be installed as a non-exporting load-displacement system to qualify for the rebate. TRU Off Grid manages the full process, including system design, installation, permitting, and rebate support.`}
        img={"/images/solar-hrs-rebate.png"}
        reverse={true}
        imgBorderRad={true}
      />

 <div
        style={{ padding: "80px 0px 80px 0px" }}
        className="main "
      >
          <TestimonialsBox />
      </div>
 <div
        style={{ padding: "80px 0px 80px 0px" }}
        className="main "
      >
         <h2 className="h1_main pb-3">System Education</h2>
         <a href="./system-guide.pdf" download="Tru Off Grid System Guide.pdf" style={{textDecoration:"none"}}>
          <button className="button_main">
                   Download Guide
                  </button>
          </a>
        <VerticalSlider/>
      </div>

      <div
        style={{ padding: "80px 0px 80px 0px" }}
        className="main text-center"
      >
        <Container>
          <Row className="gy-4 gx-5">
            <Col lg={6}>
              <div className={styles.contentCol}>
                <h3 className="h2_main pb-2">Contact us</h3>
                <h2 className="h1_main pb-4">
                  Need help with your solar project? <span>Lets Talk</span>
                </h2>
                <Row>
                  <Col className="pt-3" lg={12}>
                    <a
                      style={{ textDecoration: "none" }}
                      href="tel:905-299-7841"
                    >
                      <div className={styles.info}>
                        <img src="/images/phone.svg" alt="icon" />
                        <p className="para_main">905-299-7841</p>
                      </div>
                    </a>
                  </Col>
                  <Col className="pt-3" lg={12}>
                    <a
                      style={{ textDecoration: "none" }}
                      href="mailto: sales@truoffgrid.com"
                    >
                      <div className={styles.info}>
                        <img src="/images/mail.svg" alt="icon" />
                        <p className="para_main">sales@truoffgrid.com</p>
                      </div>
                    </a>
                  </Col>
                  <Col className="pt-3" lg={12}>
                    <a
                      style={{ textDecoration: "none" }}
                      target="no_blank"
                      href="https://www.google.com/maps/dir//TRU+Off+Grid+-+Solar+%26+Energy+Storage,+348+Bronte+St.+S+Unit+21,+Milton,+ON+L9T+5B6/@43.5108146,-79.963851,12z/data=!4m8!4m7!1m0!1m5!1m1!1s0x267e0b12cb8a4ddf:0xae5c0834e6f5863a!2m2!1d-79.8791121!2d43.4996211?entry=ttu&g_ep=EgoyMDI2MTAxMy4wIKXMDSoASAFQAw%3D%3D"
                    >
                      <div className={styles.info}>
                        <img src="/images/location.svg" 
alt="icon"/>
                        <p className="para_main">
                          348 Bronte St., South Unit #21 Milton, ON (Please give
                          us a call, send an email or complete the Let's Get in
                          Touch form. Thanks)
                        </p>
                      </div>
                    </a>
                  </Col>
                </Row>
              </div>
            </Col>
            
            <Col lg={6}>
              <div className={styles.formCol}>
                <h2 className="h1_main pb-2">Let’s get in touch!</h2>
                <p className="para_main pb-5">
                  Lets discuss your project and find out what we can do
                </p>
                {loading ? (
                  <div className="row pb-4">
                    <div className="col-12">
                      <Spinner
                        animation="border"
                        role="status"
                        style={{ color: "black" }}
                      />
                    </div>
                  </div>
                ) : success ? (
                  <div className="row pb-4">
                    <div className="col-12">
                      <p className="para_main" style={{ color: "black" }}>
                        {success}
                      </p>
                    </div>
                  </div>
                ) : (
                  error && (
                    <div className="row pb-4">
                      <div className="col-12">
                        <p className="para_main" style={{ color: "black" }}>
                          {error}
                        </p>
                      </div>
                    </div>
                  )
                )}
                <form onSubmit={formSubmitHandler}>
                  <input
                    maxLength="12"
                    type="text"
                    placeholder="Your Full Name"
                    pattern=".{3,}"
                    required
                    value={name}
                    onChange={(event) => setName(event.target.value)}
                  />
                  <input
                    maxLength="36"
                    type="email"
                    placeholder="Email"
                    pattern=".{3,}"
                    required
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                  />
                  <input
                    maxLength="36"
                    type="text"
                    placeholder="Phone Number"
                    pattern=".{3,}"
                    required
                    value={phoneNum}
                    onChange={(event) => setPhoneNum(event.target.value)}
                  />
                  <input
                    style={{ resize: "none" }}
                    as="textarea"
                    maxLength="800"
                    type="text"
                    placeholder="Your Message"
                    required
                    value={message}
                    onChange={(event) => setMessage(event.target.value)}
                  />
                  <button className="button_main mt-3" type="submit">
                    Submit
                  </button>
                </form>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

 

      <div
        style={{ padding: "80px 0px 240px 0px" }}
        className="main text-center"
      >
        <Container>
          <h2 className="h1_main pb-5">Gallery</h2>
          <Row className="gy-4">
            <Col lg={6}>
              <img alt="gallery" style={{ width: "100%" }} src="/images/gallery1.webp" />
            </Col>
            <Col lg={6}>
              <img alt="gallery" style={{ width: "100%" }} src="/images/gallery2.webp" />
            </Col>
            <Col lg={6}>
              <img alt="gallery" style={{ width: "100%" }} src="/images/gallery4.webp" />
            </Col>
            <Col lg={6}>
              <img alt="gallery" style={{ width: "100%" }} src="/images/gallery5.webp" />
            </Col>
            <Col lg={6}>
              <img alt="gallery" style={{ width: "100%" }} src="/images/gallery6.webp" />
            </Col>
            <Col lg={6}>
              <img alt="gallery" style={{ width: "100%" }} src="/images/gallery7.webp" />
            </Col>
            <Col lg={6}>
              <img alt="gallery" style={{ width: "100%" }} src="/images/gallery8.webp" />
            </Col>
            <Col lg={6}>
              <img alt="gallery" style={{ width: "100%" }} src="/images/gallery3.webp" />
            </Col>
        {Array.from({ length: 43 }, (_, i) => i + 4)
  .filter((num) => num !== 15)
  .map((num) => (
    <Col lg={6} key={num}>
      <img 
        alt="gallery" 
        style={{ width: "100%" }} 
        src={`/images/gallery/gallery${num}.webp?v=2`} 
      />
    </Col>
  ))}
          </Row>
        </Container>
      </div>
      <Footer newsletter={true} />
    </>
  );
};

export default SolarAndWindPower;
